<div class="code-snippet">
  <pre><code [highlight]="value" [languages]="['bash']"></code></pre>
  <app-copy-text-button [value]="value"></app-copy-text-button>
</div>
